import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { type Program } from "../../../zodios/apiDefinitions/api/programs";
import { errorToast } from "../../../utils/toasts";
import { useProgramContext } from "../../../components/custom/programs/ProgramContext";
import { type ProgramFormValues, toProgramFields } from "../programFormValues";

interface Options {
  /** Attaches the new program to this pricing plan. */
  pricingPlanId?: number;
  onSuccess?: (program: Program) => void;
}

export const useCreateProgram = ({ pricingPlanId, onSuccess }: Options) => {
  const { t } = useTranslation(["programs"]);
  const { engine } = useProgramContext();

  return useMutation({
    mutationFn: async ({ values, templateType }: { values: ProgramFormValues; templateType: string }) =>
      await apiClient.createProgram({
        ...toProgramFields(values, templateType),
        template_type: templateType,
        engine,
        status: "paused",
        pricing_plan: pricingPlanId,
      }),
    onSuccess,
    onError: (error) => {
      errorToast({ message: t(($) => $.programs["Failed to create the program"]), error });
    },
  });
};
